import { Component, Injector, OnInit } from "@angular/core";
import { BaseComponent } from "../base/base.component";
import { PublicationService } from "../services/publication/publication.service";
import { PublishingListItem } from "../services/publishing/PagedPublishingList";
import { PublishingService } from "../services/publishing/publishing.service";
import { Excel } from "../services/Excel/excel.service";

@Component({
  selector: "app-search-publication",
  templateUrl: "./search-publication.component.html",
  styleUrls: ["./search-publication.component.css"],
})
export class SearchPublicationComponent
  extends BaseComponent
  implements OnInit
{
  publicationYears: string[] = [];
  publicationService: PublicationService;
  publicationYear: string;
  private publishingService: PublishingService;
  totalItems: number;
  publications: PublishingListItem[] = [];
  excelService: Excel;
  isOpen: boolean = false;

  constructor(public _injector: Injector) {
    super(_injector);
    this.publicationService = this._injector.get(PublicationService);
    this.publishingService = this._injector.get(PublishingService);
    this.excelService = this._injector.get(Excel);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.publicationYears = ["Select a Year"];
    this.publicationService.getPublicationYears().subscribe((years) => {
      if (years != null && years.length > 0) {
        this.publicationYears = this.publicationYears.concat(years);
      }
    });
    this.setPublicationYear(this.publicationYears[0]);
  }

  setPublicationYear(year: any) {
    this.publicationYear = this.publicationYears.find((yr) => yr == year);
    this.onSearchClick();
  }

  onSearchClick() {
    this.totalItems = 0;

    this.showProgress();
    this.publishingService
      .GetPublications(this.publicationYear)
      .subscribe((publicationList: PublishingListItem[]) => {
        this.totalItems = publicationList.length;
        this.publications = undefined;
        if (publicationList !== null && publicationList.length !== 0) {
          this.publications = publicationList;
        }
        this.hideProgress();
      });
  }

  GoToPublication(publishing: PublishingListItem) {
    this.router.navigateByUrl("publications/" + publishing.publishingId);
  }

  Print() {
    window.print();
  }

  exportAsXLSX(): void {
    let dataForExcel = [];
    this.publications.forEach((item) => {
      dataForExcel.push(
        Object.values({
          Publication_Year: item.year,
          Publication_Date: item.publishDate,
          Volume_Issue: item.volumeIssue,
        })
      );
    });

    let reportData = {
      title: "PublicationsReport",
      data: dataForExcel,
      headers: Object.keys({ Year: 0, PublishDate: 0, VolumeIssue: 0 }),
    };

    this.excelService.exportAsExcelFile(reportData);
  }
}
